import React, { useState, useEffect } from "react";
import { InputBase, makeStyles, Paper, Card, Typography, } from "@material-ui/core";
import swal from '@sweetalert/with-react';
import '../database/directorydatabase/alertbutton.styles.css'
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles({
  root: {
    top: "110px",
    left: "590px",
    width: "220px",
    height: "75px",
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: "1px solid var(--unnamed-color-d8d8d8)",
    boxShadow: "0px 0px 10px #00000033",
    borderRadius: "3px",
    opacity: 1,
    position: "absolute",
    zIndex: 3,
    ["@media (max-width: 900px)"]: {
      display: 'none',
    }
  },
  vertical: {
    position: "absolute",
    top: "-8px",
    left: "110px",
    border: "0px",
    margin: "0px",
    borderLeft: "2px solid #D8D8D8",
    height: "50px",
    float: "left",
  },
  input: {
    fontFamily: 'Montserrat',
    position: "absolute",
    top: '32px',
    left: "15px",
    width: "70px",
    height: "30px",
    background: "#F2F2F2 0% 0% no-repeat padding-box",
    borderRadius: "2px",
    opacity: 1,
    '& input': {
      textIndent: "6px",
      paddingRight: '10px'
    },
    '& input::placeholder': { //This is meant to change the place holder color to green
      paddingLeft: "0px",

    }
  },
  from: {
    position: 'relative',
    top: "8px",
    left: "15px",
    width: "107px",
    height: "26px",
    textAlign: "left",
    fontSize: '14px',
    font: "normal normal medium 10px",
    fontFamily: 'Montserrat',
    letterSpacing: "0px",
    color: "#313131",
    opacity: 1,
  },
  to: {
    position: 'relative',
    top: "-19px",
    left: "98px",
    width: "107px",
    height: "26px",
    textAlign: "right",
    fontSize: '14px',
    font: "normal normal medium 10px",
    fontFamily: 'Montserrat',
    letterSpacing: "0px",
    color: "#313131",
    opacity: 1,
  },
  toInput: {
    fontWeight: '400',
    position: 'absolute',
    fontFamily: 'Montserrat',
    background: "#F2F2F2 0% 0% no-repeat padding-box",
    left: '136px',
    top: '32px',
    zIndex: 2,
    width: "70px",
    height: "30px",
    borderRadius: "2px",
    '& input': {
      textIndent: "6px",
      textAlign: 'right',
      paddingRight: '7px'
    },
    '& input::placeholder': {
      
      textAlign: "right",
      
    }
  }
});

const DateFilters = ({ data, childToParent, fromDate, toDate, setToDate, setFromDate, setIsFiltered }) => {

  const [visible, setVisible] = useState(true)
  const classes = useStyles();
  const [animation, setAnimation] = useState(true);

  // setting logic to filter between dates
  const handleFiltering = (fromDate = '', toDate = '') => {

    if (fromDate === "") {
      fromDate = '1500'
    }

    if (toDate === "") {
      toDate = '1800'

    }
    if (toDate === undefined) {
      toDate = 1800
    }

    /* if (fromDate.match(/[^0-9]/)) {
     alert('no string')
     } */

    if (fromDate > toDate && (toDate.length === 4)) {
      swal({
        content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
          <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
          <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
          <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '14px' }}>The research is failed. Please, the date must be respectively in the range of 1500 - 1800</p>
        </div>,
        button: {
          text: "OK",
          value: true,
          visible: true,
          className: "stylebutton",
          closeModal: true,
        },

      })
    }

    if (fromDate === 4 && (toDate.length === 4) < (fromDate)) {
      swal({
        content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
          <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
          <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
          <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '14px' }}>The research is failed, the first value can't be minor than the second one. Please, type always a value in the range of 1500 - 1800 </p>
        </div>,
        button: {
          text: "OK",
          value: true,
          visible: true,
          className: "stylebutton",
          closeModal: true,
        },

      })
    }

    if (fromDate.length > 4) {
      swal({
        content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
          <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
          <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
          <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '15px' }}>You can't type more than 4 numbers.</p>
        </div>,
        button: {
          text: "OK",
          value: true,
          visible: true,
          className: "stylebutton",
          closeModal: true,
        },

      })
    }

    if (fromDate.length === 4 && fromDate < 1500 || fromDate.length === 4 && fromDate > 1800) {
      swal({
        content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
          <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
          <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
          <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '15px' }}>Please, the date must be in the range of 1500 - 1800</p>
        </div>,
        button: {
          text: "OK",
          value: true,
          visible: true,
          className: "stylebutton",
          closeModal: true,
        },

      })

      if (toDate.length === 4 && toDate < 1500 || toDate.length === 4 && toDate > 1800) {
        swal({
          content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
            <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
            <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
            <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '14px' }}>Please, the date must be respectively  in the range of 1500 - 1800</p>
          </div>,
          button: {
            text: "OK",
            value: true,
            visible: true,
            className: "stylebutton",
            closeModal: true,
          },

        })

      }
    }


    /*  if (fromDate >= toDate) {
      fromDate = toDate
      } */


    /* if ( toDate === undefined){
       toDate = 1800
       
     }*/

    let filter = false;
    if ('' !== fromDate || '' !== toDate) {
      const checkDate =
        (fromDate.length && 4 === fromDate.length && !toDate.length) ||
        (fromDate.length && fromDate.length === 4 && toDate.length &&
          toDate.length === 4 &&
          parseInt(toDate) >= parseInt(fromDate)) ||
        (!fromDate.length && toDate.length === 4);

      if (checkDate) {
      //  console.log('1-', fromDate)
     //   console.log('2-', toDate)
        filter = true;
        const filteredData = data.filter(element => {
          return element.eventDate >= parseInt(fromDate) && element.eventDate <= parseInt(toDate)
        })
        childToParent(filteredData)
      }
    }

    if ('' === fromDate && '' === toDate) {
      childToParent([])
      setIsFiltered(false);
    } else {
     // console.log('2')
      setIsFiltered(filter)
    };

  }
  useEffect(() => {
    setVisible(true);
  }, [])


  const handleFromDate = (e) => {
    const param = e.currentTarget.value
    setFromDate(param)
    handleFiltering(param)


  }

  const handleToDate = (e) => {
    const param = e.currentTarget.value
    setToDate(param)
    handleFiltering(param)
  }

  useEffect(() => {
    if (fromDate === "" && toDate === "") {
      setIsFiltered(false);
      setFromDate("")
      setToDate("")
    } else {
      handleFiltering(fromDate, toDate)
    }
  }, [data, fromDate, toDate])

  return (
    <>
      {visible ?
      <Fade in={animation === true} timeout={3000}>
        <Paper className={classes.root}>
          <Typography className={classes.from}>From Year</Typography>
          <InputBase type="number" 
          value={fromDate} 
          className={classes.input} 
          placeholder="1500" 
          onChange={handleFromDate} />
          <hr className={classes.vertical} />
          <Typography className={classes.to} >To Year</Typography>
          <InputBase type="number" 
          value={toDate}
          className={classes.toInput} 
          placeholder="1800" 
          onChange={handleToDate} />
        </Paper></Fade> : null}

    </>
  );
};

export default DateFilters;

